<template>
    <v-combobox
    v-model="val"
    :items="authors"
    :label="label"
    item-text="preferredUsername"
    multiple
  >
  </v-combobox>
</template>

<script>

export default {
  name: 'AuthorSelector',
  props: ['authors', 'label'],
  computed: {
    val: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/components/matches/AuthorSelector.vue